import { render, staticRenderFns } from "./tingfujiDetail.vue?vue&type=template&id=f191e370&"
import script from "./tingfujiDetail.vue?vue&type=script&lang=js&"
export * from "./tingfujiDetail.vue?vue&type=script&lang=js&"
import style0 from "./tingfujiDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports